// extracted by mini-css-extract-plugin
export default {"wrapper":"item_wrapper__I7Vu4","thumbnail":"item_thumbnail__vuGe6"};